/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  modeMaintenance: false,
  baseEndpoint: 'https://api.softgas.mx',
  baseEndpointPHP: 'https://api-php.softgas.mx/api/v1',
  baseEndpointDev: 'https://softgas-dev.herokuapp.com',
  baseEndpointDevPHP: 'https://softgas-api-php-testing.herokuapp.com/api/v1',
  oldFilesApi: 'https://us-central1-amimegustalagasolina-1f93a.cloudfunctions.net/fileGenerator',
  firebaseApi: 'http://localhost:5000/amimegustalagasolina-1f93a/us-central1',
  urlReceipt: 'https://sandbox-dashboard.openpay.mx/paynet-pdf/mk85dwplbzajjx0dxbra',
  urlReceiptSpei: 'https://sandbox-dashboard.openpay.mx/spei-pdf/mk85dwplbzajjx0dxbra',
  firebase: {
    apiKey: 'AIzaSyDRyLL5UGef9tfTsoPwkSmTCe7raVqMQ1o',
    authDomain: 'amimegustalagasolina-1f93a.firebaseapp.com',
    databaseURL: 'https://amimegustalagasolina-1f93a.firebaseio.com',
    projectId: 'amimegustalagasolina-1f93a',
    storageBucket: 'amimegustalagasolina-1f93a.appspot.com',
    messagingSenderId: '915163467713',
    appId: '1:915163467713:web:4c46528f1412b27558a940',
  },
};
